const DEFAULT_DELAY = 5000;

export const createErrorNotificationLimiter = ({
    delay = DEFAULT_DELAY,
    now = Date.now
} = {}) => {
    const shownAtByStatus = new Map();

    return (status, showNotification) => {
        const currentTime = now();
        const lastShownAt = shownAtByStatus.get(status);

        if (lastShownAt !== undefined && currentTime - lastShownAt < delay) {
            return;
        }

        shownAtByStatus.set(status, currentTime);
        showNotification();
    };
};
